// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__tKqUa","left":"StickyBox_left__14I36","right":"StickyBox_right__2krxF"};